import React from "react";

import styles from "./Sale.module.scss";
import Dropdown from "../../../UI/Dropdown/Dropdown";

const DropdownsInfo = [
  {
    id: 0,
    title: "Перейдите в корзину и проверьте заказ",
    text: "Регистрация на сайте — это доступ к личному кабинету. Вы сможете добавлять ткани в избранное, отслеживать историю ваших заказов, а также оформлять заказ и заполнять данные доставки в один клик.",
  },
  {
    id: 1,
    title: "Выберите необходимые товары",
    text: "Воспользуйтесь каталогом или фильтрами для поиска интересующих Вас товаров. Выберите цвет из ассортимента, введите необходимый метраж и добавьте товар «в корзину». Заказ необходимо оформить в течение 24 часов, по истечении этого времени корзина обнуляется.",
  },
  {
    id: 2,
    title: "Перейдите в корзину и проверьте заказ",
    text: "Перейдя в корзину, вы увидите полный список товара, с метражом, ценой за метр и суммой за отрез. Вы можете удалять, редактировать и оставлять комментарии для каждого товара непосредственно из списка.",
  },
  {
    id: 3,
    title: "Заполните данные для доставки",
    text: "Для оформления заказа необходимо ввести данные получателя, способ и адрес доставки. Если Вы являетесь получателем и данные вашего профиля достоверны, Вы сможете заполнить форму в один клик или вписать необходимые данные вручную.",
  },
  {
    id: 4,
    title: "Ожидайте подтверждение заказа на e-mail",
    text: "После того, как заказ будет оформлен, вам поступит подтверждение на e-mail, указанный при регистрации на сайте. В нем вы увидите полный список товаров и номер заказа. Как только заказ будет принят в обработку, вам поступит ещё одно сообщение с информацией о смене его статуса. С вами свяжется менеджер удобным для вас способом, подтвердит наличие товаров и сообщит возможные способы оплаты.",
  },
  {
    id: 5,
    title: "Оплата",
    text: "Для оплаты покупки вы будете перенаправлены на платежный шлюз АО «ТБанк» для ввода реквизитов вашей карты. Пожалуйста, приготовьте Вашу пластиковую карту заранее. Соединение с платежным шлюзом и передача информации осуществляется в защищенном режиме с использованием протокола шифрования SSL. В случае если ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или MasterCard Secure Code, для проведения платежа также может потребоваться ввод специального пароля. Способы и возможность получения паролей для совершения интернет-платежей Вы можете уточнить в банке, выпустившем карту. Настоящий сайт поддерживает 128-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается АО «ТБанк». Введенная информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ.  Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платежных систем MasterCard Europe Sprl, МИР и Visa Int.",
  },
];

const Sale: React.FC = () => {
  return (
    <section className={styles.sale}>
      <div className={styles.body}>
        <div className="title">При оплате оптовых заказов наличными действует скидка в размере 5%</div>
        <div className={styles.dropdowns}>
          {DropdownsInfo.map((item) => (
            <div className={styles.item} key={item.id}>
              <Dropdown mode="saleDropdown" number={item.id + 1} title={item.title} text={item.text} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sale;
